import React from 'react';

import "./core-arrow1.css"

const coreArrow1 = (props: coreArrow1Config) => {
	const getArrowColor = () => {
		const defaultColor = props.bgColor ?? 'black';
		return props.isHovering ? (props.hoverColor ?? defaultColor) : defaultColor
	}
	return (
		<div className='core-arrow1-arrow-container'>
			<div className='core-arrow1-arrow-head' style={{
				borderLeft: `6px solid ${getArrowColor()}`,
				borderTop: `6px solid ${getArrowColor()}`
			}}>

			</div>
			<div className='core-arrow1-arrow-tail center-element' style={{
				backgroundColor: getArrowColor()
			}}>
			</div>
		</div>
	);

};

export interface coreArrow1Config {
	isHovering?: boolean;
	bgColor?: string;
	hoverColor?: string;
}

export default coreArrow1;